import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useFORMS_COUNTER_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'FORMS_COUNTER',
    name: t('widgets.formsCounter.name'),
    description: t('widgets.formsCounter.description'),
    color: 'blue',
    icon: 'RiTimerLine',
    categories: [t('widgets.formsCounter.category')],
    previewWidth: '45%',

    initialState: {
      name: t('widgets.formsCounter.initialStateName'),
      size: { width: 25, height: 175 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
